import Hero from "./components/Hero";
import Features from "./components/Features";
import Testimonial from "./components/Testimonial";
import FAQ from "./components/FAQ";
import LastCTA from "./components/LastCTA";

const Home = () => {
  return (
    <>
      <Hero />
      <Features />
      <Testimonial />
      <FAQ />
      <LastCTA />
    </>
  );
};

export default Home;
